<template>
  <div class="brand">
    <breadcrumbs
      :breadcrumbsData="breadcrumbsData"
      #icon
      class="brandBreadcrumbs"
    >
      <svg class="icon" aria-hidden="true" style="fill: #fff">
        <use xlink:href="#icon-CC" class="icon-CC"></use>
      </svg>
     
    </breadcrumbs>
    <!-- <artmisads-segmented-tabs
      v-model="activeTab"
      :items="programConfig"
      :disabled="load"
      @change="onTabChange"
    /> -->
    <div class="top">
<segmentedTabs
      v-model="activeTab"
      :items="programConfig"
      :disabled="load"
      @change="onTabChange"
    />
     <div class="guideContainer" @click.prevent="clickGuide">
        <a-image
          class="wenhaoStyle"
          :src="require('@/assets/images/img/wenhao.png')"
          :preview="false"
          :alt="$t('seller.sellerAccount.guideAlt')"
        />
        <span class="guideText">{{ $t('seller.sellerAccount.guideLinkText') }}</span>
      </div>
    </div>
    
    <div class="table" v-if="!showGuide">
      <artmisads-table
        v-model:pagination="pagination"
        :columns="columns"
        :data-source="dataSource"
        :change="onTableChange"
        :loading="load"
        :noData="noData"
      >
        <template #bodyCell="{ column, record }">
          <template v-if="column.key == 'status'">
            <Status
              :type="returnStatusType(record)"
              :text="returnStatus(record)"
              :noBorder="true"
            />
          </template>
          <template v-if="column.key == 'activeBrandCount'">
            <div
              style="cursor: pointer"
              @click="handleClick(record.activeBrandCount, 'activeBrandCount')"
            >
              <a class="linkStyle" href="#">
                {{ record.activeBrandCount }}
              </a>
            </div>
          </template>
          <template v-if="column.key == 'inactiveBrandCount'">
            <div
              style="cursor: pointer"
              @click="
                handleClick(record.inactiveBrandCount, 'inactiveBrandCount')
              "
            >
              <a class="linkStyle" href="#">
                {{ record.inactiveBrandCount }}
              </a>
            </div>
          </template>
          <template v-if="column.key == 'actions'">
            <artmisads-select-button
              @click="handleBtnClick(record, 'start')"
              v-if="record.showStartBtn"
              size="small"
           
              >{{ $t('seller.sellerAccount.btnSubmitAuthorization') }}</artmisads-select-button
            >
            <artmisads-select-button
              @click="handleBtnClick(record, 'active')"
              v-if="record.showActiveBtn && activeTab === '0'"
              size="small"
              
              >{{ $t('seller.sellerAccount.btnAuthorizeBrand') }}</artmisads-select-button
            >
          </template>
        </template>
      </artmisads-table>
    </div>
    <div class="guideContent" v-else>
      <div class="titleStyle">
        {{
          activeTab === '0'
            ? $t('seller.sellerAccount.guideTitleInviteSeller')
            : $t('seller.sellerAccount.guideTitleInviteBrand')
        }}
      </div>
      <div class="steps-box">
        <a-steps v-model:current="current" direction="vertical">
          <a-step v-for="(item, index) in stepInfo" :key="item.id">
            <template #title>
              <div class="titleStyle">{{ item.title }}</div>
            </template>
            <template #description>
              <div :class="`${item.defineOptionsClass} descriptionStyle`">
                <a-image
                  v-if="item.image"
                  class="guideImage"
                  :src="item.image"
                  :alt="$t('seller.sellerAccount.guideAlt')"
                />
              </div>
            </template>
          </a-step>
        </a-steps>
      </div>
    </div>
    <authorizationModal
      ref="authorizationModalRef"
      @submit="submit"
      @clickGuide="clickGuide"
    />
  </div>
</template>
<script setup lang="jsx">import i18n from '~/i18n'

import breadcrumbs from '../breadcrumbs.vue'
import { useRouter, useRoute } from 'vue-router'
import { sellerAccountApi } from '~/server'
import { ref, onMounted, computed, reactive, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { message } from 'ant-design-vue'
import authorizationModal from './components/authorizationModal.vue'
import Status from '~/components/Status.vue'
import segmentedTabs from '~/components/segmentedTabs.vue'

const { t, locale } = useI18n()
const load = ref(false)
const router = useRouter()
const route = useRoute()
const showGuide = ref(false)
const authorizationModalRef = ref(null)
const programConfig = computed(() => [
  { label: t('seller.sellerAccount.tabAmazonSellerAccount'), key: '0' },
  { label: t('seller.sellerAccount.tabBrands'), key: '1' },
])

const getEmbedSellerSteps = () => [
  {
    id: '0',
    title: t('seller.sellerAccount.embedSellerStep0'),
    defineOptionsClass: 'descriptionStyleOne',
    image: '',
  },
  {
    id: '1',
    title: t('seller.sellerAccount.embedSellerStep1'),
    defineOptionsClass: 'descriptionStyleTwo',
    image: require('@/assets/images/img/step_two_en.png'),
  },
  {
    id: '2',
    title: t('seller.sellerAccount.embedSellerStep2'),
    defineOptionsClass: 'descriptionStyleThree',
    image: require('@/assets/images/img/step_three_en.png'),
  },
  {
    id: '3',
    title: t('seller.sellerAccount.embedSellerStep3'),
    defineOptionsClass: 'descriptionStyleFour',
    image: require('@/assets/images/img/step_four_en.png'),
  },
  {
    id: '4',
    title: t('seller.sellerAccount.embedSellerStep4'),
    defineOptionsClass: 'descriptionStyleFive',
    image: require('@/assets/images/img/step_five_en.png'),
  },
]

const getEmbedBrandSteps = () => [
  {
    id: '0_brand',
    title: t('seller.sellerAccount.embedBrandStep0'),
    defineOptionsClass: 'descriptionStyleOne',
    image: '',
  },
  {
    id: '1_brand',
    title: t('seller.sellerAccount.embedBrandStep1'),
    defineOptionsClass: 'descriptionStyleTwo',
    image: require('@/assets/images/img/step_two_brand_en.png'),
  },
  {
    id: '2_brand',
    title: t('seller.sellerAccount.embedBrandStep2'),
    defineOptionsClass: 'descriptionStyleThree',
    image: require('@/assets/images/img/step_three_brand_en.png'),
  },
  {
    id: '3_brand',
    title: t('seller.sellerAccount.embedBrandStep3'),
    defineOptionsClass: 'descriptionStyleFour',
    image: require('@/assets/images/img/step_four_brand_en.png'),
  },
]

const stepInfo = ref(getEmbedSellerSteps())

watch(locale, () => {
  if (!showGuide.value) return
  stepInfo.value =
    activeTab.value === '0' ? getEmbedSellerSteps() : getEmbedBrandSteps()
})

const clickGuide = () => {
  window.open('/seller/sellerAccount/authorization/guide', '_blank')
}

const recordId = ref('')
const current = ref(0)
const dataSource = ref([])
const activeTab = ref('0')
const pagination = reactive({
  total: 0,
  defaultPageSize: 10,
  size: 10,
  current: 1,
  showSizeChanger: true,
  pageSize: 10,
  pageSizeOptions: ['10', '20', '30', '40', '50'],
})

const breadcrumbsData = computed(() => ({
  title: t('seller.sellerAccount.breadcrumbAuthorization'),
  des: t('seller.sellerAccount.pageDesAuthorization'),
  hasTitleIcon: true,
  color: '#835cf2',
  links: [
    { name: t('seller.common.home'), path: '/seller/dashboard' },
    {
      name: t('seller.menu.creatorConnections'),
      path: '/seller/creatorConnections/accBonusProgram',
    },
    {
      name: t('seller.sellerAccount.breadcrumbAuthorization'),
      path: '/seller/creatorConnections/authorization',
    },
  ],
}))

const columns = computed(() => {
  if (showGuide.value) return []
  if (activeTab.value === '0') {
    return [
      {
        title: t('seller.sellerAccount.colAccount'),
        dataIndex: 'amazonName',
        key: 'amazonName',
      },
      {
        title: t('seller.sellerAccount.colStatus'),
        dataIndex: 'status',
        key: 'status',
      },
      {
        title: t('seller.sellerAccount.colActiveBrands'),
        dataIndex: 'activeBrandCount',
        key: 'activeBrandCount',
      },
      {
        title: t('seller.sellerAccount.colInactiveBrands'),
        dataIndex: 'inactiveBrandCount',
        key: 'inactiveBrandCount',
      },
      {
        title: t('seller.sellerAccount.colActions'),
        dataIndex: 'actions',
        key: 'actions',
      },
    ]
  }
  if (route.query.brand) {
    return [
      {
        title: t('seller.common.brand'),
        dataIndex: 'brandName',
        key: 'brand',
      },
      {
        title: t('seller.sellerAccount.colStatus'),
        dataIndex: 'brandStatus',
        key: 'status',
      },
      {
        title: t('seller.sellerAccount.colActions'),
        dataIndex: 'actions',
        key: 'actions',
      },
    ]
  }
  return [
    {
      title: t('seller.common.brand'),
      dataIndex: 'brandName',
      key: 'brand',
    },
    {
      title: t('seller.sellerAccount.colStatus'),
      dataIndex: 'brandStatus',
      key: 'status',
    },
    {
      title: t('seller.common.amazonSellerName'),
      dataIndex: 'amazonName',
      key: 'amazonName',
    },
    {
      title: t('seller.sellerAccount.colActions'),
      dataIndex: 'actions',
      key: 'actions',
    },
  ]
})

const onTabChange = (key, id) => {
  pagination.current = 1
  if (showGuide.value) {
    stepInfo.value = key === '0' ? getEmbedSellerSteps() : getEmbedBrandSteps()
    return
  }
  if (key === '0') {
    getAmazonSellerAccountList()
  } else {
    getBrandsList(id)
  }
}
const onTableChange = ({ current, pageSize }) => {
  pagination.current = current
  pagination.size = pageSize
  pagination.pageSize = pageSize
  // getData({ page: current, size: pageSize })
}
const getAmazonSellerAccountList = async () => {
  load.value = true
  const res = await sellerAccountApi.getConnectionsList({
    page: pagination.current,
    size: pagination.size,
  })
  const { data, success, error } = res
  if (success) {
    dataSource.value = data.data
    pagination.total = data.total
  } else {
    message.error(error)
  }
  load.value = false
  // if(res.code==0){
  //   dataSource.value=res.data.connections
  //   pagination.total=res.data.total
  // }
}
const getBrandsList = async (id) => {
  load.value = true
  const res = await sellerAccountApi.getBrandsList({
    page: pagination.current,
    size: pagination.size,
    amazonUserId: id,
  })
  const { data, success, error } = res
  if (success) {
    dataSource.value = data.data
    pagination.total = data.total
  } else {
    message.error(error)
  }
  load.value = false
  // if(res.code==0){
  //   dataSource.value=res.data.connections
  //   pagination.total=res.data.total
  // }
}
const handleClick = (record, key) => {
  if (key === 'inactiveBrandCount') {
    activeTab.value = '1'
    onTabChange(activeTab.value)
  } else {
    router.push(`/seller/creatorConnections/campaigns`)
  }
}
const handleBtnClick = async (record, key) => {
  if (key === 'start') {
    authorizationModalRef.value.show()
    if (activeTab.value == '0') {
      recordId.value = record.id
    } else {
      recordId.value = record.brandId
    }
  } else if (key === 'active') {
    activeTab.value = '1'
    onTabChange(activeTab.value, record.amazonUserId)
  }
}
const submit = () => {
  if (activeTab.value == '0') {
    sellerAccountApi
      .sellerAuthorization({
        id: recordId.value,
      })
      .then((res) => {
        if (res.success) {
          message.success(i18n.global.t('seller.msg.authorizationSuccess'))
          getAmazonSellerAccountList()
        } else {
          message.error(res.error)
        }
      })
  } else {
    sellerAccountApi
      .sellerBrandAuthorization({
        brandId: recordId.value,
      })
      .then((res) => {
        if (res.success) {
          message.success(i18n.global.t('seller.msg.authorizationSuccess'))
          getBrandsList()
        } else {
          message.error(res.error)
        }
      })
  }
}
const returnStatus = (record) => {
  if (activeTab.value == '0') {
    if (
      (record.status == 'active' && !record.ccStatus) ||
      record.ccStatus == 'not_authorized'
    ) {
      record.showStartBtn = true
      record.showActiveBtn = false
      return t('seller.sellerAccount.statusNotStarted')
    } else if (record.ccStatus == 'pending') {
      record.showStartBtn = false
      record.showActiveBtn = false
      return t('seller.sellerAccount.statusPending')
    } else if (record.ccStatus == 'authorized') {
      record.showStartBtn = false
      record.showActiveBtn = true
      return t('seller.sellerAccount.statusAuthorized')
    }
  } else {
    if (
      (record.brandStatus == 'active' && !record.brandCcStatus) ||
      record.brandCcStatus == 'not_authorized'
    ) {
      record.showStartBtn = true
      record.showActiveBtn = false
      return t('seller.sellerAccount.statusNotStarted')
    } else if (record.brandCcStatus == 'pending') {
      record.showStartBtn = false
      record.showActiveBtn = false
      return t('seller.sellerAccount.statusPending')
    } else if (record.brandCcStatus == 'authorized') {
      record.showStartBtn = false
      record.showActiveBtn = true
      return t('seller.sellerAccount.statusAuthorized')
    }
  }
}
const returnStatusType = (record) => {
  if (activeTab.value == '0') {
    if (
      (record.status == 'active' && !record.ccStatus) ||
      record.ccStatus == 'not_authorized'
    ) {
      return 'inactiveAuthorization'
    } else if (record.ccStatus == 'pending') {
      return 'pending'
    } else if (record.ccStatus == 'authorized') {
      return 'active'
    }
  } else {
    if (
      (record.brandStatus == 'active' && !record.brandCcStatus) ||
      record.brandCcStatus == 'not_authorized'
    ) {
      return 'inactiveAuthorization'
    } else if (record.brandCcStatus == 'pending') {
      return 'pending'
    } else if (record.brandCcStatus == 'authorized') {
      return 'active'
    }
  }
}
onMounted(() => {
  if (route.query.brand) {
    activeTab.value = '1'
    getBrandsList()
  } else {
    activeTab.value = '0'
    getAmazonSellerAccountList()
  }
})
</script>
<style lang="less">
.top{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.linkStyle{
  color: rgba(15, 6, 41, 1);
}
.ant-steps-item-container {
  margin-top: 24px !important;
}

.artmisads-button.small {
  line-height: 15px !important;
}

.titleStyle {
  color: #1d2129;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-family: 'PingFang SC';
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
}

.descriptionStyle {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 12px;
  overflow: hidden;

  .ant-image {
    max-width: 100% !important;
    max-height: 100% !important;
  }

  .guideImage {
    max-width: 100% !important;
    max-height: 100% !important;
    object-fit: contain;
  }
}

.descriptionStyleOne {
  width: 332px;
  height: 179px;

  border-radius: 10px;
  background: #c4c4c4;
}

.descriptionStyleTwo {
  width: 684px;
  height: 179px;

  border-radius: 10px;
  background: #c4c4c4;
}

.descriptionStyleThree {
  width: 417px;
  height: 231px;

  border-radius: 10px;
  background: #c4c4c4;
}

.descriptionStyleFour {
  width: 417px;
  height: 231px;

  border-radius: 10px;
  background: #c4c4c4;
}

.descriptionStyleFive {
  width: 684px;
  height: 179px;

  border-radius: 10px;
  background: #c4c4c4;
}

.artmisads-segmented-tabs {
  margin-top: 0px !important;
}

.steps-box {
  margin-top: 30px;
}

.guideContent {
  border-radius: var(--Radius-Radius-10, 10px);
  padding: 20px 24px;
  border: 1px solid #fff;
  background: #fff;
  box-shadow: 0 1px 4px 0 #0000000a, 0 2px 16px 0 #00000014;

  .title {
    font-family: 'PingFang SC';
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
  }
}

.guideContainer {
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 14px;
  background: #fff5e4;
  padding: 8px 16px;
  border: 1px solid #ff9619;
  border-radius: 6px;


  .wenhaoStyle {
    width: 26px !important;
    height: 26px !important;
  }

  .guideText {
    color: #0f0629b3;
    font-family: 'Sora';
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
  }
}

.brand {
  padding: 16px;
  padding-top: unset;
}

.linkStyle {
  text-decoration: underline;
}

.brandBreadcrumbs {
  position: relative;
}

.table {
  padding: 16px !important;
  // margin: 0 16px;
  background-color: var(--color-white);
  border-radius: 8px;
  box-shadow: var(--section-box-shadow-6);
  // border: 2px solid #E8E5ED;
}
</style>
